module.exports = __webpack_public_path__ + "img/补骨脂.0074a239.jpg";